'use strict';exports.__esModule = true;exports.buildPackageDataForPayment = exports.possibleProductNames = exports.currency = exports.getPaymentsNumber = exports.getDefaultSelectedPackageForUpdate = exports.getDefaultSelectedPackage = exports.getPackagePeriods = exports.getPackages = exports.rocketPackages = exports.periods = exports.packageTypes = exports.PACKAGE_FEATURES = exports.PROMOTIONS = undefined;var _period, _ref2, _period2, _ref3, _period3, _ref4, _period4, _ref5, _period5, _period6, _period7, _period8, _period9, _period10, _period11, _period12, _period13, _period14;var _moment = require('moment/moment');var _moment2 = _interopRequireDefault(_moment);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineEnumerableProperties(obj, descs) {for (var key in descs) {var desc = descs[key];desc.configurable = desc.enumerable = true;if ("value" in desc) desc.writable = true;Object.defineProperty(obj, key, desc);}return obj;}

var PROMOTIONS = exports.PROMOTIONS = {
  PROPERTIES: 'properties',
  HIGHLIGHTS: 'highlight',
  AUTO_JUMPS: 'autojump',
  TOP_AD: 'top_promotion' };


var PACKAGE_FEATURES = exports.PACKAGE_FEATURES = {
  PROPERTIES: PROMOTIONS.PROPERTIES,
  UNLIMITED_AGENTS: 'unlimited_agents',
  VIRTUAL_NUMBERS: 'virtual_numbers',
  COMPANY_PAGE: 'page',
  HIGHLIGHTS: PROMOTIONS.HIGHLIGHTS,
  AUTO_JUMPS: PROMOTIONS.AUTO_JUMPS,
  TOP_AD: PROMOTIONS.TOP_AD };


var buildRealtorPackageDetails = function buildRealtorPackageDetails(
priceForAdPerMonth,
adsQuantity,
unlimitedAgents,
virtualNumbers,
companyPage,
highlightsQuantity,
autojumpsQuantity,
topPromotionQuantity) {var _price, _ref, _mutatorMap;return _ref = {

    priceForAdPerMonth: priceForAdPerMonth }, _ref[
  PACKAGE_FEATURES.PROPERTIES] = adsQuantity, _ref[
  PACKAGE_FEATURES.UNLIMITED_AGENTS] = unlimitedAgents, _ref[
  PACKAGE_FEATURES.VIRTUAL_NUMBERS] = virtualNumbers, _ref[
  PACKAGE_FEATURES.COMPANY_PAGE] = companyPage, _ref[
  PACKAGE_FEATURES.HIGHLIGHTS] = highlightsQuantity, _ref[
  PACKAGE_FEATURES.AUTO_JUMPS] = autojumpsQuantity, _ref[
  PACKAGE_FEATURES.TOP_AD] = topPromotionQuantity, _price = 'price', _mutatorMap = {}, _mutatorMap[_price] = _mutatorMap[_price] || {}, _mutatorMap[_price].get = function ()
  {
    return this.priceForAdPerMonth * this[PACKAGE_FEATURES.PROPERTIES];
  }, _defineEnumerableProperties(_ref, _mutatorMap), _ref;};


var buildPublisherPackageDetails = function buildPublisherPackageDetails(price, discount, autojump, highlight) {var top_promotion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;return {
    price: price,
    discount: discount,
    autojump: autojump,
    highlight: highlight,
    top_promotion: top_promotion };};


var buildLeadPackageDetails = function buildLeadPackageDetails(quantity, price, oldPrice) {return {
    quantity: quantity,
    price: price,
    oldPrice: oldPrice };};


var buildRocketPackageDetails = function buildRocketPackageDetails(period, perDay, price) {return {
    period: period,
    perDay: perDay,
    price: price };};


var packageTypes = exports.packageTypes = {
  REGULAR: 'regular',
  PROMOTED: 'promoted',
  PREMIUM: 'premium',
  TOP: 'top',
  LEADS: 'leads',
  ROCKET: 'rocket' };


var periods = exports.periods = {
  ONE_MONTH: 1,
  THREE_MONTHS: 3,
  TEN_DAYS: 10,
  TWELVE_MONTHS: 12,
  FOURTEEN_DAYS: 14,
  THIRTY_DAYS: 30,
  TWENTY_ONE_DAYS: 21,
  FOREVER: 'forever' };


var realtorPackages = [(_ref2 = {

  id: 1 }, _ref2[
PROMOTIONS.PROPERTIES] = 10, _ref2.
period = (_period = {}, _period[
periods.ONE_MONTH] = buildRealtorPackageDetails(
24.9,
10,
true,
true,
false,
0,
0,
0), _period[

periods.TWELVE_MONTHS] = buildRealtorPackageDetails(
19.9,
10,
true,
true,
true,
0,
0,
0), _period), _ref2), (_ref3 = {




  id: 2 }, _ref3[
PROMOTIONS.PROPERTIES] = 25, _ref3.
period = (_period2 = {}, _period2[
periods.ONE_MONTH] = buildRealtorPackageDetails(
17.96,
25,
true,
true,
false,
0,
0,
0), _period2[

periods.TWELVE_MONTHS] = buildRealtorPackageDetails(
14.36,
25,
true,
true,
true,
1,
0,
0), _period2), _ref3), (_ref4 = {




  id: 3 }, _ref4[
PROMOTIONS.PROPERTIES] = 50, _ref4.
period = (_period3 = {}, _period3[
periods.ONE_MONTH] = buildRealtorPackageDetails(
13.98,
50,
true,
true,
false,
1,
2,
0), _period3[

periods.TWELVE_MONTHS] = buildRealtorPackageDetails(
11.18,
50,
true,
true,
true,
2,
5,
0), _period3), _ref4), (_ref5 = {




  id: 4 }, _ref5[
PROMOTIONS.PROPERTIES] = 100, _ref5.
period = (_period4 = {}, _period4[
periods.ONE_MONTH] = buildRealtorPackageDetails(
11.99,
100,
true,
true,
false,
2,
3,
0), _period4[

periods.TWELVE_MONTHS] = buildRealtorPackageDetails(
9.59,
100,
true,
true,
true,
5,
10,
1), _period4), _ref5)];





var publisherPackages = [
{
  id: 1,
  type: packageTypes.REGULAR,
  period: (_period5 = {}, _period5[
  periods.THIRTY_DAYS] = buildPublisherPackageDetails(0, 0, false, false), _period5) },


{
  id: 2,
  type: packageTypes.PROMOTED,
  period: (_period6 = {}, _period6[
  periods.THIRTY_DAYS] = buildPublisherPackageDetails(150, 0, true, false), _period6) },


{
  id: 3,
  type: packageTypes.PREMIUM,
  period: (_period7 = {}, _period7[
  periods.THIRTY_DAYS] = buildPublisherPackageDetails(200, 10, true, true), _period7) },


{
  id: 4,
  type: packageTypes.TOP,
  period: (_period8 = {}, _period8[
  periods.THIRTY_DAYS] = buildPublisherPackageDetails(350, 0, false, false, true), _period8) }];




var leadsPackages = [
{
  id: 'lead_package_1',
  type: packageTypes.LEADS,
  period: (_period9 = {}, _period9[
  periods.FOREVER] = buildLeadPackageDetails(1, 99, null), _period9) },


{
  id: 'lead_package_2',
  type: packageTypes.LEADS,
  period: (_period10 = {}, _period10[
  periods.FOREVER] = buildLeadPackageDetails(5, 470, 495), _period10) },


{
  id: 'lead_package_3',
  type: packageTypes.LEADS,
  period: (_period11 = {}, _period11[
  periods.FOREVER] = buildLeadPackageDetails(15, 1366, 1485), _period11) }];




var rocketPackages = exports.rocketPackages = [
{
  id: 'rocket_package_1',
  type: packageTypes.ROCKET,
  periods: periods.TEN_DAYS,
  period: (_period12 = {}, _period12[
  periods.TEN_DAYS] = buildRocketPackageDetails(10, 35, 350), _period12) },


{
  id: 'rocket_package_2',
  type: packageTypes.ROCKET,
  mostPopular: true,
  periods: periods.FOURTEEN_DAYS,
  period: (_period13 = {}, _period13[
  periods.FOURTEEN_DAYS] = buildRocketPackageDetails(14, 30, 420), _period13) },


{
  id: 'rocket_package_3',
  type: packageTypes.ROCKET,
  periods: periods.TWENTY_ONE_DAYS,
  period: (_period14 = {}, _period14[
  periods.TWENTY_ONE_DAYS] = buildRocketPackageDetails(21, 27, 567), _period14) }];




var packagePeriod = [periods.ONE_MONTH, periods.TWELVE_MONTHS];
var publisherPackagePeriod = [periods.THIRTY_DAYS, periods.TWENTY_ONE_DAYS];

var defaultSelectedRealtorPackage = {
  checked: realtorPackages[2].id,
  period: packagePeriod[0] };


var defaultSelectedPublisherPackage = {
  checked: publisherPackages[0].id,
  period: publisherPackagePeriod[0],
  alternativePeriod: publisherPackagePeriod[1] };


var defaultSelectedPublisherPackageForUpdate = {
  checked: publisherPackages[2].id,
  period: publisherPackagePeriod[0],
  alternativePeriod: publisherPackagePeriod[1] };


var getPackages = exports.getPackages = function getPackages(isRealtor) {var selectedPackageType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  switch (selectedPackageType) {
    case packageTypes.LEADS:
      return leadsPackages;
    case packageTypes.ROCKET:
      return rocketPackages;
    default:
      return isRealtor ? realtorPackages : publisherPackages;}

};

var getPackagePeriods = exports.getPackagePeriods = function getPackagePeriods(isRealtor) {return isRealtor ? packagePeriod : publisherPackagePeriod;};
var getDefaultSelectedPackage = exports.getDefaultSelectedPackage = function getDefaultSelectedPackage(isRealtor) {return isRealtor ?
  defaultSelectedRealtorPackage :
  defaultSelectedPublisherPackage;};

var getDefaultSelectedPackageForUpdate = exports.getDefaultSelectedPackageForUpdate = function getDefaultSelectedPackageForUpdate() {return defaultSelectedPublisherPackageForUpdate;};

var getPaymentsNumber = exports.getPaymentsNumber = function getPaymentsNumber(period, packageType) {return (
    period === periods.THIRTY_DAYS || period === periods.FOREVER || packageType === packageTypes.ROCKET ?
    1 :
    period);};


var currency = exports.currency = {
  ILS: 'ILS' };


var possibleProductNames = exports.possibleProductNames = {
  HIGHLIGHT: 'color_promotion',
  AUTO_JUMP: 'auto_jump',
  PROPERTIES_PACKAGE: 'properties_package',
  TOP: 'top_promotion',
  LEADS: 'leads_package',
  ROCKET: 'rocket_promotion' };


var possibleProducts = function possibleProducts(period) {return [
  {
    clientKey: 'properties',
    serverKey: possibleProductNames.PROPERTIES_PACKAGE },

  {
    clientKey: 'period[' + period + '].highlight',
    serverKey: possibleProductNames.HIGHLIGHT },

  {
    clientKey: 'period[' + period + '].autojump',
    serverKey: possibleProductNames.AUTO_JUMP },

  {
    clientKey: 'period[' + period + '].top_promotion',
    serverKey: possibleProductNames.TOP },

  {
    clientKey: 'period[' + periods.FOREVER + '].quantity',
    serverKey: possibleProductNames.LEADS },

  {
    clientKey: 'period[' + period + '].period',
    serverKey: possibleProductNames.ROCKET }];};



var buildPackageDataForPayment = exports.buildPackageDataForPayment = function buildPackageDataForPayment(currPackage, period) {
  var currentMeasure = !!currPackage.type ? 'days' : 'month';
  var buildProductItem = function buildProductItem(amount, name, term, measure) {return {
      amount: amount,
      name: name,
      until: term !== periods.FOREVER ? (0, _moment2.default)().add(term, measure) : undefined,
      property_id: currPackage.property_id || undefined };};

  var dataForPayment = possibleProducts(period).reduce(function (acc, product) {
    var data = (0, _get2.default)(currPackage, product.clientKey);
    if (!!data) {
      var promotionPeriod = product.serverKey === possibleProductNames.TOP ? 30 : period;
      var promotionMeasure = product.serverKey === possibleProductNames.TOP ? 'days' : currentMeasure;

      var item = buildProductItem(Number(data), product.serverKey, promotionPeriod, promotionMeasure);
      acc.push(item);
    }

    return acc;
  }, []);

  return dataForPayment;
};


//////////////////
// WEBPACK FOOTER
// ./src/packagesData.js
// module id = 63
// module chunks = 0